// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1qHgy","tab":"Tabs_tab__1ju0e","tabActive":"Tabs_tabActive__3hOvX"};